import React from 'react'
import { Box, Center, Text, VStack } from '@chakra-ui/react'
import { useCallTranscriptions } from './transcription.hooks'
import { useSelectedResidentContact } from '../contact-center.hooks'
import moment from 'moment'

type TranscriptionType = {}
export const Transcription: React.FC<TranscriptionType> = () => {
  const { selected } = useSelectedResidentContact()
  const transcriptions = useCallTranscriptions(selected?.phoneNumber)

  return (
    <Box
      p={3}
      minH="300px"
      maxH="450px"
      overflowY="auto"
      sx={{
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#4299e1',
          borderRadius: '3px',
          border: '2px solid #f1f1f1',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#4299e1',
        },
        scrollbarWidth: 'thin',
      }}
    >
      <Text color="gray-600" fontSize="14px" fontWeight="600" lineHeight="20px">
        Call Transcriptions
      </Text>

      {!!transcriptions?.length ? (
        <>
          <VStack spacing={4} alignItems="start" mt="10px">
            {transcriptions?.map(transcription => {
              return (
                <>
                  <Box
                    backgroundColor="#eaeef1"
                    p={4}
                    width="100%"
                    rounded="md"
                    maxH="200px"
                    overflowY="auto"
                    sx={{
                      '&::-webkit-scrollbar': {
                        width: '6px',
                      },
                      '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#4299e1',
                        borderRadius: '3px',
                        border: '2px solid #f1f1f1',
                      },
                      '&::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: '#4299e1',
                      },
                      scrollbarWidth: 'thin',
                    }}
                  >
                    <Box mt="-5px">
                      <Text fontSize="12px" fontWeight="400" color="gray.700" textAlign="right">
                        {moment.utc(transcription.callTime).local().format('MMM D, h:mm A')}
                      </Text>
                    </Box>
                    <Box mt="5px">
                      <Text fontSize="12px" color="gray.700" fontWeight="400" textAlign="justify">
                        {transcription.text}
                      </Text>
                    </Box>
                  </Box>
                </>
              )
            })}
          </VStack>
        </>
      ) : (
        <>
          <Box mt="120px">
            <Center>
              <TIcon />
            </Center>
            <Text color="#718096" fontWeight="500" fontStyle="italic" fontSize="20px" textAlign="center">
              You have no transcriptions
            </Text>
          </Box>
        </>
      )}
    </Box>
  )
}

export const TIcon = () => {
  return (
    <svg width="132" height="106" viewBox="0 0 132 106" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="132" height="106" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.296 34.45C111.338 34.45 112.992 36.111 112.992 38.16C112.992 40.2089 111.338 41.87 109.296 41.87H88.1764C90.2177 41.87 91.8724 43.531 91.8724 45.58C91.8724 47.6289 90.2177 49.29 88.1764 49.29H99.7924C101.834 49.29 103.488 50.951 103.488 53C103.488 55.0489 101.834 56.71 99.7924 56.71H94.4206C91.8468 56.71 89.7604 58.371 89.7604 60.42C89.7604 61.7859 90.8164 63.0226 92.9284 64.13C94.9697 64.13 96.6244 65.791 96.6244 67.84C96.6244 69.8889 94.9697 71.55 92.9284 71.55H49.1044C47.0632 71.55 45.4084 69.8889 45.4084 67.84C45.4084 65.791 47.0632 64.13 49.1044 64.13H28.5124C26.4712 64.13 24.8164 62.4689 24.8164 60.42C24.8164 58.371 26.4712 56.71 28.5124 56.71H49.6324C51.6737 56.71 53.3284 55.0489 53.3284 53C53.3284 50.951 51.6737 49.29 49.6324 49.29H36.4324C34.3912 49.29 32.7364 47.6289 32.7364 45.58C32.7364 43.531 34.3912 41.87 36.4324 41.87H57.5524C55.5112 41.87 53.8564 40.2089 53.8564 38.16C53.8564 36.111 55.5112 34.45 57.5524 34.45H109.296ZM109.296 49.29C111.338 49.29 112.992 50.951 112.992 53C112.992 55.0489 111.338 56.71 109.296 56.71C107.255 56.71 105.6 55.0489 105.6 53C105.6 50.951 107.255 49.29 109.296 49.29Z"
        fill="#F3F7FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.1551 33.9201L86.0527 69.8642L86.4925 73.4703C86.6342 74.632 85.8101 75.6898 84.6518 75.833L53.7175 79.6566C52.5593 79.7997 51.5054 78.974 51.3637 77.8123L46.6186 38.9091C46.5478 38.3282 46.9598 37.7993 47.539 37.7277C47.5426 37.7272 47.5463 37.7268 47.5499 37.7264L50.1164 37.4365M52.1888 37.1904L54.611 36.9169L52.1888 37.1904Z"
        fill="white"
      />
      <path
        d="M82.3935 33.7502C82.3003 33.0662 81.6703 32.5877 80.9863 32.6816C80.3024 32.7754 79.8235 33.406 79.9167 34.09L82.3935 33.7502ZM86.0527 69.8642L87.2933 69.7117C87.2926 69.7059 87.2919 69.7001 87.2911 69.6943L86.0527 69.8642ZM86.4925 73.4703L87.7332 73.3178L86.4925 73.4703ZM84.6518 75.833L84.804 77.0737L84.6518 75.833ZM53.7175 79.6566L53.8698 80.8973L53.7175 79.6566ZM51.3637 77.8123L52.6044 77.6598L51.3637 77.8123ZM46.6186 38.9091L47.8593 38.7566L46.6186 38.9091ZM47.539 37.7277L47.3868 36.487L47.539 37.7277ZM47.5499 37.7264L47.6891 38.9686L47.5499 37.7264ZM50.2555 38.6787C50.9415 38.6013 51.4353 37.9823 51.3584 37.2962C51.2816 36.6101 50.6632 36.1168 49.9772 36.1943L50.2555 38.6787ZM52.0497 35.9481C51.3637 36.0256 50.8699 36.6445 50.9467 37.3306C51.0235 38.0167 51.6419 38.5101 52.3279 38.4326L52.0497 35.9481ZM54.7501 38.1592C55.4361 38.0818 55.9299 37.4628 55.8531 36.7767C55.7763 36.0906 55.1579 35.5973 54.4719 35.6747L54.7501 38.1592ZM79.9167 34.09L84.8142 70.0341L87.2911 69.6943L82.3935 33.7502L79.9167 34.09ZM84.812 70.0167L85.2518 73.6228L87.7332 73.3178L87.2933 69.7117L84.812 70.0167ZM85.2518 73.6228C85.3104 74.1028 84.9699 74.5342 84.4996 74.5923L84.804 77.0737C86.6503 76.8455 87.958 75.1613 87.7332 73.3178L85.2518 73.6228ZM84.4996 74.5923L53.5653 78.4159L53.8698 80.8973L84.804 77.0737L84.4996 74.5923ZM53.5653 78.4159C53.0958 78.4739 52.6629 78.1392 52.6044 77.6598L50.1231 77.9648C50.348 79.8089 52.0228 81.1256 53.8698 80.8973L53.5653 78.4159ZM52.6044 77.6598L47.8593 38.7566L45.378 39.0615L50.1231 77.9648L52.6044 77.6598ZM47.8593 38.7566C47.8716 38.8574 47.8001 38.9549 47.6912 38.9684L47.3868 36.487C46.1196 36.6436 45.224 37.799 45.378 39.0615L47.8593 38.7566ZM47.6912 38.9684C47.6905 38.9685 47.6898 38.9686 47.6891 38.9686L47.4108 36.4842C47.4028 36.4851 47.3948 36.486 47.3868 36.487L47.6912 38.9684ZM47.6891 38.9686L50.2555 38.6787L49.9772 36.1943L47.4108 36.4842L47.6891 38.9686ZM52.3279 38.4326L54.7501 38.1592L54.4719 35.6747L52.0497 35.9481L52.3279 38.4326Z"
        fill="#A0AEC0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.8018 36.1826L84.2474 68.7689L84.6472 72.0381C84.7761 73.0913 84.04 74.0486 83.0033 74.1764L55.3139 77.5891C54.2771 77.7169 53.3322 76.9667 53.2034 75.9135L49.0143 41.6671C48.8802 40.5707 49.6602 39.5724 50.7565 39.4372L53.2451 39.1305"
        fill="#E8F0FE"
      />
      <path
        d="M57.5723 30.5C57.5723 28.9812 58.8035 27.75 60.3223 27.75H81.7021C82.433 27.75 83.1338 28.0409 83.6497 28.5585L89.6459 34.5737C90.1597 35.0891 90.4483 35.7873 90.4483 36.5151V67.02C90.4483 68.5388 89.2171 69.77 87.6983 69.77H60.3223C58.8035 69.77 57.5723 68.5388 57.5723 67.02V30.5Z"
        fill="white"
        stroke="#A0AEC0"
        strokeWidth="2.5"
      />
      <path
        d="M82.7227 27.7734V33.9199C82.7227 34.7981 83.4318 35.5099 84.3067 35.5099H88.4956"
        stroke="#A0AEC0"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.3047 62.54H76.0327M62.3047 35.51H76.0327H62.3047ZM62.3047 41.87H85.0087H62.3047ZM62.3047 48.76H85.0087H62.3047ZM62.3047 55.65H85.0087H62.3047Z"
        stroke="#CBD5E0"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
